import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import { Redirect } from 'react-router';
import _ from 'lodash';
import $ from 'jquery';
import API from '../../API';
import Loader from '../Loader';
import CheckoutHeader from './CheckoutHeader';
import CheckoutFooter from './CheckoutFooter';
import CheckoutColor from './CheckoutColor';
import CheckoutPopup from './CheckoutPopup';
import ContentContainer from '../ContentContainer';
import Button from '../Button';
import LocaleText from '../LocaleText';
import Form from '../Form';
import FormGroup from '../FormGroup';
import FormRow from '../FormRow';
import FormControl from '../FormControl';
import { formatAmount } from '../../helpers/formatingHelpers';
import { convertConfigToSnakeCase } from '../../helpers/generalHelpers';
import { getText } from '../../helpers/translationHelper';

class Checkout extends React.Component {
    constructor(props) {
        super(props);
        this.steps = [
            <LocaleText textKey="checkout.step.one.title" />,
            <LocaleText textKey="checkout.step.two.title" />,
        ];
        this.formSteps = {
            0: { special_colors: {} },
            1: {},
        };
        this.scrollTo = -1;
        this.onNextStep = this.onNextStep.bind(this);
        this.onPrevStep = this.onPrevStep.bind(this);
        this.onClosePopup = this.onClosePopup.bind(this);
        this.onSubmitForm = this.onSubmitForm.bind(this);
        this.onGeneratePdf = this.onGeneratePdf.bind(this);
        this.prepareOrderRequestData = this.prepareOrderRequestData.bind(this);
        this.renderAreas = this.renderAreas.bind(this);
        this.renderStepZero = this.renderStepZero.bind(this);
        this.renderStepOne = this.renderStepOne.bind(this);
        this.renderStepTwo = this.renderStepTwo.bind(this);
        this.renderStepThree = this.renderStepThree.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillUnmount() {
        this.props.setCheckoutDefaults();
    }

    onNextStep() {
        if (this.validateStep(this.props.step)) {
            if (this.props.step < this.steps.length - 1) {
                this.props.nextStep();
                $('.checkout')
                    .stop()
                    .scrollTop(0);
            } else {
                this.onSubmitForm();
            }
        }
    }

    onPrevStep() {
        if (this.props.behaviour === 'CONTACT_DETAILS_ONLY' || this.props.step === 0) {
            this.props.history.goBack();
            return;
        }

        this.props.previousStep();
    }

    onGeneratePdf() {
        if (!this.validateStep(this.props.step)) {
            return;
        }

        this.props.setIsPdfGenerating(true);

        const preparedOrderRequestData = this.prepareOrderRequestData();

        const data = $('form')
            .serializeArray()
            .reduce((obj, item) => {
                obj[item.name] = item.value;
                return obj;
            }, {});

        preparedOrderRequestData.amount = data.amount * 1;

        API.generatePdf(preparedOrderRequestData).then(response => {
            if (response.data.status === 'success') {
                this.props.setPdfUrl(response.data.path);
                this.props.setIsPdfGenerating(false);
            } else {
                console.error('Failed to generate PDF');
            }
        });
    }

    prepareOrderRequestData() {
        const images = [];
        const previews = [];
        const { config, penId, penShots } = this.props;
        const newConfig = convertConfigToSnakeCase(config);

        // collect special colors
        if (config.parts) {
            Object.keys(this.formSteps[0].special_colors).map(partName => {
                let part = config.parts[partName];
                part.special_color = this.formSteps[0].special_colors[partName].getValue();
                newConfig['parts'][partName] = part;
            });
        }

        // collect printable areas
        if (config.printableAreas) {
            Object.keys(config.printableAreas).map(key => {
                let data = config.printableAreas[key];
                const addData = {
                    colors_amount: -1,
                    extra_color: '',
                };

                if (this.formSteps[0][`colors_amount_${key}`]) {
                    addData.colors_amount =
                        this.formSteps[0][`colors_amount_${key}`].getValue() * 1;
                }

                if (this.formSteps[0][`extra_color_${key}`]) {
                    addData.extra_color = this.formSteps[0][`extra_color_${key}`].getValue();
                }

                Object.assign(data, addData);
                newConfig['printable_areas'][key] = data;

                const img = this.getPrintableAreaImage(config.printableAreas[key]);
                images.push(img);
            });
        }

        // collect engraving areas
        if (config.engravingAreas) {
            Object.keys(config.engravingAreas).map(key => {
                const img = this.getPrintableAreaImage(config.engravingAreas[key]);
                images.push(img);
            });
        }

        // convert preview images
        if (penShots) {
            penShots.forEach(shot => {
                previews.push({
                    src: shot,
                });
            });
        }

        // build order
        return {
            pen_id: penId,
            config: newConfig,
            images: images,
            preview_images: previews,
        };
    }

    onSubmitForm() {
        const contact = {};
        const order = this.prepareOrderRequestData();

        // get all form inputs
        const data = $('form')
            .serializeArray()
            .reduce((obj, item) => {
                obj[item.name] = item.value;
                return obj;
            }, {});

        // collect contact data
        const contactKeys = [
            'first_name',
            'second_name',
            'email',
            'phone',
            'fax',
            'country',
            'company',
            'street',
            'street_number',
            'zip',
            'city',
            'note',
            'client_number',
        ];
        contactKeys.forEach(key => {
            contact[key] = data[key] || '';
        });

        // enhance order object with contact data and order amount
        order.contact_data = contact;
        order.amount = data.amount * 1;

        this.props.setIsLoading(true);

        // console.log(JSON.stringify(order, undefined, 4));
        API.sendOrderRequest(JSON.stringify(order, undefined, 4), this.props.locale)
            .then(result => {
                // show done screen
                this.props.setStep(2);
                this.props.setIsLoading(false);

                $('.checkout')
                    .stop()
                    .scrollTop(0);
            })
            .catch(error => {
                if (error.response.status === 422 && error.response.data.fields.length) {
                    this.handleErrors(error.response.data.fields);
                } else {
                    // show error screen
                    this.props.setStep(3);
                    this.props.setIsLoading(false);
                    $('.checkout')
                        .stop()
                        .scrollTop(0);
                }
            });
    }

    handleErrors(fields) {
        let step = 0;

        fields.forEach(section => {
            Object.keys(section).forEach(field => {
                section[field].forEach(error => {
                    let key = Object.keys(error.data)[0];

                    switch (error.code) {
                        case 29:
                            key = error.key.replace('missing', error.data[0]);
                            break;
                        default:
                            break;
                    }

                    for (let i = 1; i >= 0; i -= 1) {
                        Object.keys(this.formSteps[i]).map(name => {
                            const control = this.formSteps[i][name];
                            if (name === key && typeof control.setError === 'function') {
                                control.setError(true);
                                step = i;
                            }
                        });
                    }
                });
            });
        });

        this.props.setStep(step);
        this.props.setIsLoading(false);

        $('.checkout')
            .stop()
            .scrollTop(0);
    }

    handleInputChange(value) {
        if (this.props.pdfUrl !== null) {
            this.props.setPdfUrl(null);
        }
    }

    onClosePopup() {
        this.setState({ showPopup: false });
        this.props.setIsErrorPopupVisible();

        if (this.scrollTo !== -1) {
            $('.checkout')
                .stop()
                .animate(
                    {
                        scrollTop: this.scrollTo,
                    },
                    600
                );

            this.scrollTo = -1;
        }
    }

    validateStep(step) {
        let error = false;
        let first = null;
        const controls = this.formSteps[step];

        Object.keys(controls).map(key => {
            let valid = true;
            if (typeof controls[key].doValidate === 'function') {
                valid = controls[key].doValidate();
            }
            error = error || !valid;
            if (!valid && first === null) {
                first = controls[key];
            }
        });

        if (first) {
            // get scroll position of first error
            const item = first[first.props.type] || first.input;
            const rect = item.getBoundingClientRect();
            const $checkout = $('.checkout');

            this.scrollTo = $checkout.scrollTop() + rect.top - 50;

            this.props.setIsErrorPopupVisible(true);
        }

        return !error;
    }

    getPrintableAreaImage(area) {
        const { customImages, customTexts } = this.props;
        let img = null;

        if (area.type === 'image' && customImages) {
            const index = customImages.findIndex(o => {
                return o.id === area.image;
            });
            img = customImages[index];
        } else if (area.type === 'text' && customTexts) {
            const index = customTexts.findIndex(o => {
                return o.id === area.text;
            });
            img = customTexts[index]['image'];
        }

        return img;
    }

    getPrintableAreaColor(area) {
        const { customTexts } = this.props;
        let color = null;

        if (area.type === 'text' && customTexts) {
            const index = customTexts.findIndex(o => {
                return o.id === area.image;
            });
            color = customTexts[index]['color'];
        }

        return color;
    }

    renderParts() {
        const { config } = this.props;

        if (!config.parts || !Object.keys(config.parts).length) {
            return null;
        }

        const colors = Object.keys(config.parts).map(key => {
            const item = config.parts[key];
            const partName = <LocaleText textKey={key} />;
            const material = <LocaleText textKey={item.material} />;
            return (
                <div className="color_input_group">
                    <CheckoutColor
                        key={key}
                        color={item.color}
                        copy={[partName, '', material]}
                        colorPos={1}
                    />
                    <FormControl
                        type="text"
                        maxlength={90}
                        name={`special_color_${key}`}
                        label={<LocaleText textKey="checkout.special.colors" />}
                        onChange={this.handleInputChange}
                        ref={ref => {
                            this.formSteps[0].special_colors[key] = ref;
                        }}
                    />
                </div>
            );
        });

        return (
            <FormGroup legend={<LocaleText textKey="checkout.parts.title" />}>
                <div className="checkout__color-wrapper">{colors}</div>
            </FormGroup>
        );
    }

    renderAreas(areaType) {
        const { config } = this.props;
        let output = null;

        if (!config[areaType] || !Object.keys(config[areaType]).length) {
            return output;
        }

        const el = Object.keys(config[areaType]).map(key => {
            const area = config[areaType][key];
            const img = this.getPrintableAreaImage(area);
            let style = {};

            if (area.background_color) {
                style.backgroundColor = `rgb(${area.background_color.r},${
                    area.background_color.g
                },${area.background_color.b})`;
            }

            if (!img || !img.src) {
                return;
            }

            const printColorsAmount1 = getText('checkout.printing.colors.amount.one');
            const printColorsAmount2 = getText('checkout.printing.colors.amount.two');
            const printColorsAmount3 = getText('checkout.printing.colors.amount.three');
            const printColorsAmount4 = getText('checkout.printing.colors.amount.four');

            output = (
                <div key={key} className="checkout__printarea">
                    <div className="checkout__printarea-title">{key}</div>
                    <div className="row">
                        <div className="col">
                            <input
                                type="hidden"
                                name={`image[${key}]`}
                                value={img.id}
                                ref={ref => {
                                    this.formSteps[0][`image-${key}`] = ref;
                                }}
                            />
                            <div className="checkout__printarea-area" style={style}>
                                <div
                                    className="checkout__printarea-image"
                                    style={{ backgroundImage: `url(${img.src})` }}
                                />
                            </div>
                        </div>
                        {areaType === 'printableAreas' && (
                            <div className="col">
                                <FormControl
                                    type="select"
                                    name={`colors_amount_${key}`}
                                    label={<LocaleText textKey="checkout.printing.colors" />}
                                    required
                                    onChange={this.handleInputChange}
                                    ref={ref => {
                                        this.formSteps[0][`colors_amount_${key}`] = ref;
                                    }}
                                >
                                    <option value="1" selected>
                                        {printColorsAmount1}
                                    </option>
                                    <option value="2">
                                        {printColorsAmount2}
                                    </option>
                                    <option value="3">
                                        {printColorsAmount3}
                                    </option>
                                    <option value="4">
                                        {printColorsAmount4}
                                    </option>
                                </FormControl>
                                <FormControl
                                    type="input"
                                    name={`extra_color_${key}`}
                                    onChange={this.handleInputChange}
                                    label={<LocaleText textKey="checkout.special.colors" />}
                                    ref={ref => {
                                        this.formSteps[0][`extra_color_${key}`] = ref;
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            );

            return output;
        });

        let legend = '';
        switch (areaType) {
            case 'printableAreas':
                legend = <LocaleText textKey="checkout.printable.areas.title" />;
                break;
            case 'engravingAreas':
                legend = <LocaleText textKey="checkout.engraving.areas.title" />;
                break;
            default:
                break;
        }

        output = (
            <FormGroup legend={legend}>
                <div className="checkout__printarea-wrapper">{el}</div>
            </FormGroup>
        );

        return output;
    }

    renderMine() {
        const { config, mine } = this.props;
        const copy = [];

        if (!config || !mine || _.isEmpty(config.mine_color) || _.isEmpty(mine)) {
            return null;
        }

        if (mine.description) {
            copy.push(mine.description);
        }

        if (mine.name) {
            copy.push(mine.name);
        }

        const labelKey = mine.id ? 'checkout.mine.title' : 'checkout.writing.color.title';

        return (
            <FormGroup legend={<LocaleText textKey={labelKey} />}>
                <div className="checkout__mine">
                    <div className="row">
                        <div className="col">
                            {mine.image && <img src={mine.image} alt="mine" />}
                            <CheckoutColor color={config.mine_color} copy={copy} />
                        </div>
                    </div>
                </div>
            </FormGroup>
        );
    }

    renderCountryOptions() {
        const optionKey = 'checkout.form.country.option.';
        const countries = [];
        const options = [];
        const { texts } = this.props;

        // collect option translations
        Object.keys(texts).map(key => {
            if (key.indexOf(optionKey) === 0) {
                countries.push([key.slice(optionKey.length), texts[key]]);
            }
        });

        // sort by country name
        countries.sort(function(a, b) {
            a = a[1]
                .toUpperCase()
                .replace(/Ä/g, 'A')
                .replace(/Ö/g, 'O')
                .replace(/Ü/g, 'U');
            b = b[1]
                .toUpperCase()
                .replace(/Ä/g, 'A')
                .replace(/Ö/g, 'O')
                .replace(/Ü/g, 'U');
            return a < b ? -1 : a > b ? 1 : 0;
        });

        countries.forEach(country => {
            options.push(
                <option key={country[0]} value={country[0]}>
                    {country[1]}
                </option>
            );
        });

        return options;
    }

    renderStepZero() {
        const { minOrderAmount } = this.props.config;
        return (
            <section data-step="0">
                <h1>{this.props.penName}</h1>

                <FormGroup legend={<LocaleText textKey="checkout.order.amount" />}>
                    <img className="pen" src={this.props.penShots[0]} alt="" />
                    <FormControl
                        type="amount"
                        name="amount"
                        min={minOrderAmount}
                        status={
                            <LocaleText
                                textKey="checkout.min.order.amount"
                                args={[formatAmount(minOrderAmount)]}
                            />
                        }
                        onChange={this.handleInputChange}
                        ref={ref => {
                            this.formSteps[0]['amount'] = ref;
                        }}
                    />
                </FormGroup>

                {this.renderParts()}

                {this.renderAreas('printableAreas')}

                {this.renderAreas('engravingAreas')}

                {this.renderMine()}
            </section>
        );
    }

    renderStepOne() {
        const inputAmount = this.props.isStatic ?
            <input
                type="hidden"
                name="amount"
                value={ this.props.minOrderAmount }
            /> : '';
        return (
            <section data-step="1">
                <h1>
                    <LocaleText textKey="checkout.step.two.title" />
                </h1>
                { inputAmount }
                <FormGroup legend={<LocaleText textKey="checkout.form.personal.details.title" />}>
                    <FormRow>
                        <FormControl
                            type="text"
                            name="second_name"
                            maxlength={100}
                            label={<LocaleText textKey="checkout.form.last.name.label" />}
                            required
                            ref={ref => {
                                this.formSteps[1]['second_name'] = ref;
                            }}
                        />
                        <FormControl
                            type="text"
                            name="first_name"
                            maxlength={100}
                            label={<LocaleText textKey="checkout.form.first.name.label" />}
                            required
                            ref={ref => {
                                this.formSteps[1]['first_name'] = ref;
                            }}
                        />
                    </FormRow>
                    <div className="row">
                        <div className="col">
                            <FormControl
                                type="text"
                                name="company"
                                maxlength={100}
                                label={<LocaleText textKey="checkout.form.company.label" />}
                                required
                                ref={ref => {
                                    this.formSteps[1]['company'] = ref;
                                }}
                            />
                        </div>
                        <div className="col">
                            <FormControl
                                type="text"
                                name="street"
                                label={<LocaleText textKey="checkout.form.street.label" />}
                                className="form-control--size-b-s"
                                maxlength={100}
                            />
                            <FormControl
                                type="text"
                                name="street_number"
                                label={<LocaleText textKey="checkout.form.street.no.label" />}
                                maxlength={10}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormControl
                                type="text"
                                name="zip"
                                label={<LocaleText textKey="checkout.form.zip.label" />}
                                className="form-control--size-s-b"
                                required
                                ref={ref => {
                                    this.formSteps[1]['zip'] = ref;
                                }}
                                maxlength={10}
                            />
                            <FormControl
                                type="text"
                                name="city"
                                label={<LocaleText textKey="checkout.form.city.label" />}
                                required
                                ref={ref => {
                                    this.formSteps[1]['city'] = ref;
                                }}
                                maxlength={100}
                            />
                        </div>
                        <div className="col">
                            <FormControl
                                type="select"
                                name="country"
                                label={<LocaleText textKey="checkout.form.country.label" />}
                                required
                                ref={ref => {
                                    this.formSteps[1]['country'] = ref;
                                }}
                            >
                                {this.renderCountryOptions()}
                            </FormControl>
                        </div>
                    </div>
                </FormGroup>

                <FormGroup legend={<LocaleText textKey="checkout.contact.details.title" />}>
                    <div className="row">
                        <div className="col">
                            <FormControl
                                type="email"
                                name="email"
                                label={<LocaleText textKey="checkout.form.email.label" />}
                                required
                                ref={ref => {
                                    this.formSteps[1]['email'] = ref;
                                }}
                                maxlength={100}
                            />
                        </div>
                        <div className="col">
                            <FormControl
                                type="text"
                                name="client_number"
                                label={<LocaleText textKey="checkout.form.customer.nr.label" />}
                                ref={ref => {
                                    this.formSteps[1]['client_number'] = ref;
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <FormControl
                                type="text"
                                name="phone"
                                label={<LocaleText textKey="checkout.form.phone.label" />}
                                ref={ref => {
                                    this.formSteps[1]['phone'] = ref;
                                }}
                                maxlength={20}
                            />
                        </div>
                        <div className="col">
                            <FormControl
                                type="text"
                                name="fax"
                                label={<LocaleText textKey="checkout.form.fax.label" />}
                                ref={ref => {
                                    this.formSteps[1]['fax'] = ref;
                                }}
                                maxlength={20}
                            />
                        </div>
                    </div>
                </FormGroup>

                <FormGroup legend={<LocaleText textKey="checkout.questionbox.title" />}>
                    <p>
                        <LocaleText textKey="checkout.questionbox.copy" />
                    </p>
                    <FormControl
                        type="textarea"
                        name="note"
                        // placeholder={<LocaleText textKey="checkout.questionbox.placeholder"/>}
                        ref={ref => {
                            this.formSteps[1]['note'] = ref;
                        }}
                    />
                    <FormControl
                        hidden
                        type="checkbox"
                        name="catalog"
                        value="1"
                        ref={ref => {
                            this.formSteps[1]['catalog'] = ref;
                        }}
                    >
                        <LocaleText textKey="checkout.questionsbox.label" />
                    </FormControl>
                </FormGroup>
            </section>
        );
    }

    renderStepTwo() {
        const { locale } = this.props;
        return (
            <section data-step="2">
                <div className="checkout__done">
                    <div className="checkout__done-inner">
                        <span>
                            <h1>
                                <LocaleText textKey="checkout.affirmation.title" />
                            </h1>
                            <p>
                                <LocaleText textKey="checkout.affirmation.copy" />
                            </p>
                            <Isvg src="/svg/confirm.svg" />
                        </span>
                    </div>
                    <div className="checkout__done-footer">
                        <Button className="is-primary is-bigger" to={`/${locale}/pens`}>
                            <LocaleText textKey="checkout.affirmation.cta" />
                        </Button>
                    </div>
                </div>
            </section>
        );
    }

    renderStepThree() {
        const { locale } = this.props;
        return (
            <section data-step="3">
                <div className="checkout__done">
                    <div className="checkout__done-inner">
                        <span>
                            <h1>
                                <LocaleText textKey="checkout.fatal.error.title" />
                            </h1>
                            <p>
                                <LocaleText textKey="checkout.fatal.error.copy" />
                            </p>
                        </span>
                    </div>
                    <div className="checkout__done-footer">
                        <Button className="is-primary is-bigger" to={`/${locale}/pens`}>
                            <LocaleText textKey="checkout.fatal.error.cta" />
                        </Button>
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const {
            step,
            isErrorPopupVisible,
            isLoading,
            isPdfGenerating,
            pdfUrl,
            behaviour,
            penId,
            locale,
        } = this.props;
        const isShowingPopup = isErrorPopupVisible || isLoading;

        if (!penId) {
            return <Redirect to={`/${locale}/pens`} />;
        }

        return (
            <div className={`checkout${isShowingPopup ? ' is-showing-popup' : ''}`}>
                <CheckoutHeader steps={this.steps} current={step} />

                <ContentContainer>
                    <Form current={step}>
                        {this.renderStepZero()}
                        {this.renderStepOne()}
                        {this.renderStepTwo()}
                        {this.renderStepThree()}
                    </Form>
                </ContentContainer>

                {step === 3 || step === 2 ? null : (
                    <CheckoutFooter
                        steps={this.steps}
                        current={step}
                        onNext={this.onNextStep}
                        onPrev={this.onPrevStep}
                        onGeneratePdf={this.onGeneratePdf}
                        showGeneratePdf={step === 0 && !pdfUrl}
                        showPdfDownload={step === 0 && pdfUrl}
                        isPdfGenerating={isPdfGenerating}
                        pdfUrl={pdfUrl}
                    />
                )}

                <CheckoutPopup
                    show={isErrorPopupVisible}
                    onClose={this.onClosePopup}
                    title={<LocaleText textKey="checkout.popup.title" />}
                >
                    <p>
                        <LocaleText textKey="checkout.popup.error.copy" />
                    </p>
                </CheckoutPopup>

                <CheckoutPopup show={isLoading} plain invert>
                    <Loader />
                </CheckoutPopup>
            </div>
        );
    }
}

Checkout.propTypes = {
    config: PropTypes.object.isRequired,
};

Checkout.defaultProps = {};

export default Checkout;
